import React from 'react';
import ReactDOM from 'react-dom/client';

import './scss/font-family.scss'; 
import './scss/veraible.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs'
import './scss/header.scss';
import './scss/footer.scss';
import './scss/home-banner.scss';
import './scss/browse-home.scss';
import './scss/home-cta.scss';
import './scss/recommended-you.scss';
import './scss/browse-country.scss';
import './scss/home-real-estate-agent.scss';
import './scss/explore-result-locations.scss';
import './scss/home-see-how-can-help.scss';
import './scss/home-page-skeleton.scss';
import './scss/login-sign.scss';
import './scss/buy-page.scss';
import './scss/product-details.scss';
import './scss/product-info-section.scss';
import './scss/modal.scss';
import './scss/hero-section-banner.scss';
import './scss/why-pre-qualified.scss';
import './scss/get-pre-qualified-comp.scss'; 
import './scss/pp-tc.scss';
import './scss/mortgage-calculator.scss'; 
import './scss/see-can-afford.scss';
import './scss/calculate-your-buy-ability-comp.scss';
import './scss/buy-ability-modal.scss';
import './scss/buy-ability-result-modal.scss';
import './scss/help.scss';
import './scss/help-list.scss';
import './scss/help-detail-page.scss';
import './scss/resources.scss';
import './scss/resource-details.scss';
import './scss/career-page.scss';
import './scss/career-details-page.scss';
import './scss/real-estate-agents.scss';
import './scss/testimonials.scss';
import './scss/about-banner.scss';
import './scss/become-agent-page.scss';
import './scss/profile.scss';
import './scss/your-team.scss';
import './scss/saved-homes.scss';  
import './scss/saved-searches.scss';
import './scss/compare-homes.scss';
import './scss/common.scss';
import './scss/clients-trust.scss';
import './scss/about-box.scss';
import './scss/makes-different.scss';
import './scss/what-we-care-about.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
